"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.employeeAddRole = employeeAddRole;
exports.employeeDelRole = employeeDelRole;
exports.employeeGetInfo = employeeGetInfo;
exports.employeeRoleList = employeeRoleList;
exports.employeeUpdateRole = employeeUpdateRole;
exports.serviceStaffAddApi = serviceStaffAddApi;
exports.serviceStaffDelRoleApi = serviceStaffDelRoleApi;
exports.serviceStaffListApi = serviceStaffListApi;
exports.serviceStaffStatusApi = serviceStaffStatusApi;
exports.serviceStaffUpdateApi = serviceStaffUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 分页列表
 * @param
 */
function employeeRoleList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit,
    keywords: pram.keywords,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/merchant/employee/list',
    method: 'get',
    params: data
  });
}
/**
 * 删除
 * @param
 */
function employeeDelRole(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: 'admin/merchant/employee/delete',
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function employeeGetInfo(pram) {
  return (0, _request.default)({
    url: "/admin/merchant/employee/info/".concat(pram),
    method: 'GET'
  });
}
/**
 * 新增
 * @param
 */
function employeeAddRole(pram) {
  var data = {
    avatar: pram.avatar,
    name: pram.name,
    phone: pram.phone,
    role: pram.role,
    status: pram.status,
    uid: pram.uid,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/employee/save',
    method: 'POST',
    data: data
  });
}
/**
 * 修改
 * @param
 */
function employeeUpdateRole(pram) {
  var data = {
    avatar: pram.avatar,
    name: pram.name,
    phone: pram.phone,
    role: pram.role,
    status: pram.status,
    uid: pram.uid,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/employee/update',
    method: 'post',
    data: data
  });
}

/**
 * 员工服务分页列表
 * @param
 */
function serviceStaffListApi(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit,
    keywords: pram.keywords,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/merchant/service/staff/list',
    method: 'get',
    params: data
  });
}
/**
 * 员工服务删除
 * @param
 */
function serviceStaffDelRoleApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/service/staff/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 员工服务新增
 * @param
 */
function serviceStaffAddApi(pram) {
  var data = {
    idPhoto: pram.idPhoto,
    name: pram.name,
    phone: pram.phone,
    sort: pram.sort,
    status: pram.status,
    userId: pram.userId,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/service/staff/save',
    method: 'POST',
    data: data
  });
}
/**
 * 员工服务修改
 * @param
 */
function serviceStaffUpdateApi(pram) {
  var data = {
    idPhoto: pram.idPhoto,
    name: pram.name,
    phone: pram.phone,
    sort: pram.sort,
    status: pram.status,
    userId: pram.userId,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/merchant/service/staff/update',
    method: 'post',
    data: data
  });
}

/**
 * 员工服务修改状态
 * @param
 */
function serviceStaffStatusApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/service/staff/status/".concat(id),
    method: 'post'
  });
}